<SettingsLayout page='settings/general' label="General">
  <h1>Opciones generales</h1>

  <h2>Multimedia</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-never-mark-media-sensitive"
             bind:checked="$neverMarkMediaAsSensitive" on:change="onChange(event)">
      Mostrar multimedia sensible por defecto
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-show-all-spoilers"
             bind:checked="$showAllSpoilers" on:change="onChange(event)">
      Expand content warnings by default
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-use-blurhash"
              bind:checked="$ignoreBlurhash" on:change="onChange(event)">
      Mostrar un color gris liso para multimedia sensible
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-mark-media-sensitive"
             bind:checked="$markMediaAsSensitive" on:change="onChange(event)">
      Tratar todo multimedia como sensible
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-large-inline-media"
             bind:checked="$largeInlineMedia" on:change="onChange(event)">
      Mostrar imágenes y vídeos grandes incrustados
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-autoplay-gif"
             bind:checked="$autoplayGifs" on:change="onChange(event)">
      Reproducir automáticamente GIFs animados
    </label>
  </form>

  <h2>UI</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-custom-scrollbars"
             bind:checked="$disableCustomScrollbars" on:change="onChange(event)">
      Deshabilitar barras deslizantes personalizadas
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-infinite-scroll"
             bind:checked="$disableInfiniteScroll" on:change="onChange(event)">
      Deshabilitar
        <Tooltip
          text="desplazamiento infinito"
          tooltipText="Cuando el desplazamiento infinito esté deshabilitado, los nuevos toots no se mostrarán automáticamente al final o al principio de la cronología. En vez de esto, habrá botones que te permitirán cargar más contenido a demanda."
        />
      
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-hide-cards"
             bind:checked="$hideCards" on:change="onChange(event)">
      Ocultar paneles de previsualización de enlaces
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-underline-links"
             bind:checked="$underlineLinks" on:change="onChange(event)">
      Subrayar enlaces en toots y perfiles
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-center-nav"
             bind:checked="$centerNav" on:change="onChange(event)">
      Centrar la barra de navegación
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-bottom-nav"
             bind:checked="$bottomNav" on:change="onChange(event)">
      Situar la barra de navegación al final de la pantalla
    </label>
  </form>

  <h2>Accesibilidad</h2>
  <form class="ui-settings">
    <label class="setting-group">
      <input type="checkbox" id="choice-reduce-motion"
             bind:checked="$reduceMotion" on:change="onChange(event)">
      Reducir movimiento en animaciones de la interfaz
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-always-show-focus-ring"
             bind:checked="$alwaysShowFocusRing" on:change="onChange(event)">
      Mostrar siempre
      <Tooltip
        text="anillo del foco"
        tooltipText="El anillo del foco es el contorno que muestra el elemento que actualmente tiene el foco. Por defecto solo se muestra cuando se usa el teclado (no el ratón o un dispositivo táctil), pero puedes elegir mostrarlo siempre."
      />
      
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-tap-on-status"
             bind:checked="$disableTapOnStatus" on:change="onChange(event)">
      Deshabilitar área para tocar en todo el toot
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-omit-emoji-in-display-names"
             bind:checked="$omitEmojiInDisplayNames" on:change="onChange(event)">
      Eliminar emoji de nombres de usuario
    </label>
    <label class="setting-group">
      <input type="checkbox" id="choice-disable-long-aria-labels"
             bind:checked="$disableLongAriaLabels" on:change="onChange(event)">
      Usar etiquetas ARIA cortas para artículos
    </label>
  </form>

  {#if $isUserLoggedIn }
    <h2>{themeTitle}</h2>
    <ThemeSettings instanceName={$currentInstance} />
  {/if}
</SettingsLayout>
<UISettingsStyles />
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import ThemeSettings from '../../_components/settings/instance/ThemeSettings.html'
  import { store } from '../../_store/store.js'
  import Tooltip from '../../_components/Tooltip.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'
  import { formatIntl } from '../../_utils/formatIntl.js'

  export default {
    components: {
      SettingsLayout,
      ThemeSettings,
      Tooltip,
      UISettingsStyles
    },
    methods: {
      onChange (event) {
        // these two are mutually exclusive
        const { markMediaAsSensitive, neverMarkMediaAsSensitive } = this.store.get()
        if (markMediaAsSensitive && neverMarkMediaAsSensitive) {
          if (event.target.id === 'choice-mark-media-sensitive') {
            this.store.set({ neverMarkMediaAsSensitive: false })
          } else {
            this.store.set({ markMediaAsSensitive: false })
          }
        }

        this.store.save()
      }
    },
    store: () => store,
    computed: {
      themeTitle: ({ $loggedInInstancesInOrder, $currentInstance }) => (
        $loggedInInstancesInOrder.length > 1
          ? formatIntl(["Diseño visual para ",["instance"]], { instance: $currentInstance })
          : "Diseño visual"
      )
    }
  }
</script>
